import React from "react";
import {
	ADMIN_NAV_SECTION_LABELS,
	getAdminNavItemsForDashboard,
	groupAdminNavBySection,
} from "../../../config/adminNavigationCatalog";
import { useAdminPermissions } from "../../hooks/useAdminPermissions";
import { useIsSuperAdmin } from "../../hooks/useIsSuperAdmin";
import {
	DashboardCard,
	DashboardCardDescription,
	DashboardCardIcon,
	DashboardCardTitle,
	DashboardGrid,
	DashboardSection,
	DashboardSectionTitle,
	DashboardShell,
	DashboardTitle,
	DashboardWrap,
} from "./styled/StyledDashboard";

export default function DashBoard() {
	const { hasPermission, loaded } = useAdminPermissions();
	const { isSuperAdmin } = useIsSuperAdmin();

	// Filter by RBAC permission. Items without permission key are always visible.
	// Until permissions load, hide all permission-gated items (fail-safe).
	const allItems = getAdminNavItemsForDashboard();
	const visibleItems = allItems.filter((item) => {
		if (item.superAdminOnly && !isSuperAdmin) return false;
		if (!item.permission) return true;
		return hasPermission(item.permission);
	});
	const groups = groupAdminNavBySection(visibleItems);

	return (
		<DashboardWrap data-testid="admin-dashboard">
			<DashboardShell data-testid="admin-dashboard-shell">
				<DashboardTitle>Admin tools</DashboardTitle>
				{!loaded && <DashboardSectionTitle>Loading your access…</DashboardSectionTitle>}
				{loaded && groups.length === 0 && (
					<DashboardSectionTitle>
						You don&apos;t have access to this tool yet. Access is managed in Workspace — please contact HR
						to get a role assigned.
					</DashboardSectionTitle>
				)}
				{groups.map(({ section, items }) => (
					<DashboardSection key={section}>
						<DashboardSectionTitle>{ADMIN_NAV_SECTION_LABELS[section]}</DashboardSectionTitle>
						<DashboardGrid>
							{items.map((tool) => (
								<DashboardCard
									key={tool.to}
									to={tool.to}>
									<DashboardCardIcon className={tool.icon} />
									<DashboardCardTitle>{tool.label}</DashboardCardTitle>
									<DashboardCardDescription>{tool.description}</DashboardCardDescription>
								</DashboardCard>
							))}
						</DashboardGrid>
					</DashboardSection>
				))}
			</DashboardShell>
		</DashboardWrap>
	);
}
